const GB = {
  associationIncorporated: [
    "co-operative"
  ],
  partnershipIncorporated: [
    "limited liability partnership (LLP)",
    "Scottish limited partnership (SLP)"
  ],
  partnershipUnincorporated: [
    "limited partnership (LP)",
    "private fund limited partnership (PFLP)",
    "general partnership (GP)"
  ]
};
export {
  GB as default
};
